import SmoothScroll from 'smooth-scroll';
// Documentation: https://github.com/cferdinandi/smooth-scroll
document.addEventListener('DOMContentLoaded', function () {
    const navContainer = document.getElementById('navbar');
    const enableDisappear = navContainer?.classList.contains('js-enable-disappear');
    // All settings: https://github.com/cferdinandi/smooth-scroll#options-and-settings
    const options = {
        speed: 750,
        speedAsDuration: true,
        topOnEmptyHash: false,
        header: enableDisappear ? null : '#navbar',
        clip: true,
    };
    new SmoothScroll('a[href*="#"]:not([href="#"])', options);
    // Hide the navbar after SmoothScroll has fired to avoid any visibility issues
    if (enableDisappear) {
        document.addEventListener('scrollStop', e => {
            // @ts-expect-error - TS doesn't know about the anchor property
            const anchor = e.detail.anchor;
            if (anchor.offsetTop > 0) {
                navContainer?.classList.add('disappeared');
            }
        }, false);
    }
    // Prevent scroll-to-top default behaviour of browsers
    document.querySelectorAll('a[href="#"]').forEach(elem => elem.addEventListener('click', e => {
        e.preventDefault();
    }));
});
